<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="DEDICATION para-style-override-1" id="toc_marker-2">For the Chapel Community at Worcester College, Oxford</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?7568b34d